export default {
  modelName: 'contract_reminder',
  label: '承攬商簽約提醒管理',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    // locales: {
    //   type: 'locales',
    //   fields: {
    //     attach: {
    //       type: 'files',
    //       label: '簽約提醒附件 (請上傳PDF格式)',
    //       uploadUrl: '/contract_reminder/attach/',
    //     },
    //   },
    // },
    attach: {
      type: 'file',
      // type: 'image',
      label: '簽約提醒附件 (請上傳PDF格式)',
      uploadUrl: '/contract_reminder/attach/',
    },
    name: {
      type: 'text',
      label: '承攬商簽約提醒名稱',
      maxlength: 1000,
    },
    // updated_admin: {
    //   type: 'belongsTo',
    //   label: '最後更新人',
    //   textKey: 'name',
    //   readonly: true,
    // },
    // updated_at: {
    //   type: 'datetime',
    //   label: '更新時間',
    //   readonly: true,
    // },
    area: {
      label: '適用地區',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'area',
      rules: 'required',
      placeholder: '選擇地區',
      clearable: true,
    },
    area_section: {
      label: '適用子地區',
      type: 'belongsTo',
      textKey: 'name',
      clearable: true,
      modelName: 'area_section',
      placeholder: '選擇子地區',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    // system_class: {
    //   label: '選擇領域',
    //   type: 'belongsTo',
    //   textKey: 'name',
    //   modelName: 'system_class',
    //   requiredField: 'area',
    //   conditionKeys: [
    //     {
    //       fieldName: 'area',
    //       conditionName: 'area',
    //     },
    //   ],
    // },
    // system_subclasses: {
    //   conditionKeys: [
    //     {
    //       fieldName: 'system_class',
    //       conditionName: 'system_class',
    //       type: 'array',
    //     },
    //   ],
    //   requiredField: 'system_class',
    //   label: '選擇子領域',
    //   type: 'hasMany',
    //   textKey: 'name',
    //   modelName: 'system_subclass',
    // },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    updated_info: {
      type: 'custom',
      label: '上次修改時間',
      getValue: (item) => {
        let _value = item.updated_at;
        if (item.updated_admin) {
          _value += `  ${item.updated_admin}`;
        }
        return _value;
      },
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
  },
};
